var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ModalBase,{attrs:{"name":"crear-etiqueta","title":"Crear nueva etiqueta"},on:{"close":_setup.emitClose}},[_c(_setup.EtiquetaForm,{attrs:{"etiqueta":_setup.tempTag},on:{"terminado":_setup.crear}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }